import React from "react";
import "./Dropdown.css";

const Dropdown = ({ classOptions, currentOption, setCurrentOption }) => {
  return (
    <select
    className="ncert-dropdown"
      value={currentOption} // should be a class_id number
      onChange={(e) => setCurrentOption(Number(e.target.value))} // convert string -> number
    >
      {classOptions?.map((opt) => (
        <option key={opt.class_id} value={opt.class_id}>
          {opt.class_name}
        </option> 
      ))}
    </select>
  );
};

export default Dropdown;
